import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useCodeViewOptions} from '@github-ui/use-code-view-options'
import {useSearchParams} from '@github-ui/use-navigate'

import {useCurrentBlame} from './CurrentBlame'
import {useCurrentStyledBlob} from './CurrentStyledBlob'
import {BlobDisplayType, useBlobRendererType} from './use-blob-renderer-type'

export function useShouldUseTaillights() {
  const {codeWrappingOption} = useCodeViewOptions()
  const hasBlame = !!useCurrentBlame()
  const displayType = useBlobRendererType()
  const {rawLines, stylingDirectives} = useCurrentStyledBlob()
  const [params] = useSearchParams()
  return (
    isFeatureEnabled('code_view_enable_taillights') &&
    !codeWrappingOption.enabled &&
    !hasBlame &&
    displayType === BlobDisplayType.Code &&
    rawLines != null &&
    stylingDirectives != null &&
    params.get('h') !== '1'
  )
}
